import { render, staticRenderFns } from "./branch-box-manage.vue?vue&type=template&id=231eac12&scoped=true&"
import script from "./branch-box-manage.vue?vue&type=script&lang=js&"
export * from "./branch-box-manage.vue?vue&type=script&lang=js&"
import style0 from "./branch-box-manage.vue?vue&type=style&index=0&id=231eac12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231eac12",
  null
  
)

export default component.exports